import React, { useEffect, useState } from "react";
import { Card, Layout, Switch, Table, message } from "antd";
import ApiClient from "../../helpers/ApiClient";
import { useSytContext } from "../../common/providers/SytProvider";

const { Content } = Layout;

const RoadShowAdmin = () => {
  const { refreshRoadShowNavSetting } = useSytContext();
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [isActive, setIsActive] = useState(true);

  const loadSetting = () => {
    setLoading(true);
    ApiClient.get("StoreVisitors/roadShowNavVisible")
      .then((res) => {
        const statusCode = res?.statusCode ?? res?.status;
        if (statusCode === 200) {
          const payload = res?.data?.data ?? res?.data ?? {};
          const active =
            payload?.isActive ??
            payload?.IsActive ??
            payload?.status ??
            payload?.Status;
          setIsActive(active === true || active === 1 || active === "1");
        } else {
          setIsActive(false);
          message.error(res?.message || "Failed to load Road Show setting");
        }
      })
      .catch(() => {
        setIsActive(false);
        message.error("Failed to load Road Show setting");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadSetting();
  }, []);

  const handleStatusChange = (checked) => {
    setUpdating(true);
    ApiClient.put(
      "StoreVisitors/roadShowNavVisible",
      {},
      { isActive: checked ? 1 : 0 },
    )
      .then((res) => {
        const statusCode = res?.statusCode ?? res?.status;
        if (statusCode === 200) {
          setIsActive(checked);
          refreshRoadShowNavSetting?.();
          message.success(
            checked
              ? "Road Show tab is now Active for B2B and B2C"
              : "Road Show tab is now Inactive for all users",
          );
        } else {
          message.error(res?.message || "Failed to update status");
        }
      })
      .catch((err) => {
        message.error(err?.message || "Failed to update Road Show status");
      })
      .finally(() => setUpdating(false));
  };

  const columns = [
    {
      title: "Feature",
      dataIndex: "feature",
      key: "feature",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Status",
      key: "status",
      width: 160,
      render: () => (
        <Switch
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          checked={isActive}
          loading={updating}
          onChange={handleStatusChange}
        />
      ),
    },
  ];

  const dataSource = [
    {
      key: "road-show-nav",
      feature: "Road Show Navigation Tab",
      description:
        "Controls visibility of the Road Show menu item on B2B and B2C website headers.",
    },
  ];

  return (
    <div className="manage-markup-section">
      <Content className="container-fluid admin-container">
        <Card
          title="Road Show"
          extra={<span>{isActive ? "Visible on site" : "Hidden on site"}</span>}
        >
          <p style={{ marginBottom: 16 }}>
            Use the toggle below to show or hide the Road Show tab for all
            partners (B2B) and customers (B2C).
          </p>
          <Table
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            loading={loading}
            bordered
          />
        </Card>
      </Content>
    </div>
  );
};

export default RoadShowAdmin;
